import CountryFilter from './CountrySelect';
import { PriceFilter } from '../PriceFilter';
import useTranslation from 'next-translate/useTranslation';
import { YearFilter } from '../YearFilter';
import { CategoriesFilter } from '@/components/Form/ProductsFilter/CategoriesFilter';
import classNames from 'classnames';
import ManufacturerFilter from './ManufacturerFilter';
import { FilterIcon } from '@/components/Icons/FilterIcon';
import { IndustryCategoriesFilter } from '@/components/Form/ProductsFilter/IndustryCategoriesFilter';

export function ProductsFilter({ isMobile }: { isMobile?: boolean }) {
  const { t } = useTranslation('common');
  return (
    <form
      className={classNames({
        'hidden lg:block': !isMobile,
      })}
      data-testid={
        isMobile ? 'products-filters-mobile' : 'products-filters-desktop'
      }
    >
      <h2 className='sr-only'>Filters</h2>
      <div className='flex flex-col rounded px-6 lg:mt-8 lg:bg-zinc-100 lg:py-6'>
        <div>
          <h3 className='align-center hidden flex-row gap-1 font-medium text-gray-900 lg:flex'>
            <FilterIcon size={24} />
            {t('common:Filter')}
          </h3>
        </div>
        <IndustryCategoriesFilter />
        <CategoriesFilter />
        <PriceFilter />
        <CountryFilter returnKey='alpha2' />
        <ManufacturerFilter returnKey='name' />
        <YearFilter />
      </div>
    </form>
  );
}
